<template>
  <footer>
    <div id="anchor" class="relative max-w-[2250px] mx-auto">
      <div
        class="mer w-full h-[525px] absolute bottom-0 z-10"
        v-if="currentRouteName !== 'products' && currentRouteName !== 'game'"
      ></div>
      <div
        class="terre w-full h-[525px] absolute bottom-0 z-10"
        v-if="currentRouteName === 'game'"
      ></div>
      <div
        v-if="currentRouteName !== 'wait'"
        class="border-t border-black w-full relative z-30"
      >
        <div
          class="w-full bg-black tablet:bg-transparent max-w-none px-[2vw] laptop:px-0 desktop:px-0 laptop:max-w-[70vw] desktop:max-w-7xl mx-auto py-1 laptop:py-2"
        >
          <ul
            class="text-center tablet:flex text-[2.8vw] tablet:text-[1.7vw] laptop:text-[.9vw] desktop:text-sm justify-between items-center laptop:gap-16 uppercase text-white tablet:text-black tch font-bold"
          >
            <li>
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/67adbaff9ecf132282be728b/reglement.pdf"
                target="_blank"
                >Règlement du jeu</a
              >
            </li>
            <li class="tablet:inline-block hidden">|</li>
            <li>
              <a
                href="https://www.muscador.fr/politique-de-confidentialite/"
                target="_blank"
                >Politique de confidentialité</a
              >
            </li>
            <li class="tablet:inline-block hidden">|</li>
            <li>
              <router-link to="/mentions">Mentions légales</router-link>
            </li>
            <li class="tablet:inline-block hidden">|</li>
            <li><router-link to="/contact">Contactez-nous</router-link></li>
          </ul>
        </div>
      </div>
      <div
        class="desktop:h-10 border-t border-white tablet:border-none h-[6vw] tablet:h-[4.5vw] laptop:h-[2.5vw] bg-black tablet:bg-white/50 flex justify-center items-center relative z-30"
      >
        <div
          class="text-center w-full relative z-20 text-[4vw] tablet:text-[2.9vw] laptop:text-[1.8vw] desktop:text-2xl text-white tablet:text-[#878787]"
        >
          L'abus d'alcool est dangereux pour la santé, à consommer avec
          modération.
        </div>
      </div>

      <div
        v-if="
          currentRouteName !== 'home' &&
          currentRouteName !== 'home2' &&
          currentRouteName !== 'products' &&
          currentRouteName !== 'form' &&
          currentRouteName !== 'game'
        "
        class="w-full laptop:w-[25%] h-[600px] bottom-0 bottle absolute z-20"
      ></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer-view",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss">
.bottle {
  background-image: url("@/assets/images/bottle-desk.png");
  background-size: 545px auto;
  background-position: bottom left calc(100%);
  background-repeat: no-repeat;

  @media (max-width: 1919px) {
    background-size: 110% auto;
  }

  @media (max-width: 1024px) {
    background-image: url("@/assets/images/bottle2.png");
    background-size: 95% auto;
    background-position: bottom -2vw left -1vw;
  }

  @media (max-width: 1023px) {
    display: none;
  }
}
.mer {
  background-image: url("@/assets/images/musca-bas-village-3.png");
  background-size: 2350px auto;
  background-position: bottom -55px center;
  background-repeat: no-repeat;

  @media (max-width: 1919px) {
    background-size: 118% auto;
    background-position: bottom -2.9vw center;
  }
  @media (max-width: 1024px) {
    background-size: 150% auto;
    background-position: bottom -5.3vw right -11vw;
  }

  @media (max-width: 1023px) {
    display: none;
  }
}

.terre {
  background-image: url("@/assets/images/musca-bas-vide.png");
  background-size: 2350px auto;
  background-position: bottom -55px center;
  background-repeat: no-repeat;

  @media (max-width: 1919px) {
    background-size: 118% auto;
    background-position: bottom -2.9vw center;
  }
  @media (max-width: 1024px) {
    background-size: 158% auto;
    background-position: bottom -3vw right -21vw;
  }

  @media (max-width: 640px) {
    background-position: bottom 43vw right -25vw;
  }
}
</style>
